import React from 'react';

interface SystemTaskIconProps {
    fill?: string;
}

export const SystemTaskIcon = ({ fill }: SystemTaskIconProps) => {
    switch (fill) {
        case 'labor':
            return (
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="32" height="32" rx="16" fill="#D9FFF3" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.3335 8.50065C17.0323 8.50065 15.1668 10.3661 15.1668 12.6673C15.1668 13.3725 15.3414 14.0345 15.6489 14.6148C15.8202 14.9382 15.7605 15.3355 15.5018 15.5942L8.84534 22.2507L9.75016 23.1555L16.4066 16.4991C16.6653 16.2403 17.0626 16.1806 17.386 16.352C17.9664 16.6595 18.6283 16.834 19.3335 16.834C21.6347 16.834 23.5002 14.9685 23.5002 12.6673C23.5002 12.385 23.4722 12.1097 23.4189 11.8437L21.1728 14.0899C20.8473 14.4153 20.3197 14.4153 19.9942 14.0899L17.9109 12.0066C17.5855 11.6811 17.5855 11.1535 17.9109 10.8281L20.1571 8.58188C19.8911 8.52861 19.6158 8.50065 19.3335 8.50065ZM13.5002 12.6673C13.5002 9.44565 16.1118 6.83398 19.3335 6.83398C20.3172 6.83398 21.2464 7.07818 22.0613 7.50996C22.295 7.63375 22.456 7.86107 22.4953 8.12254C22.5345 8.38401 22.4474 8.64861 22.2604 8.83557L19.6787 11.4173L20.5835 12.3221L23.1652 9.7404C23.3522 9.55343 23.6168 9.46629 23.8783 9.50556C24.1397 9.54483 24.3671 9.70586 24.4909 9.9395C24.9226 10.7544 25.1668 11.6836 25.1668 12.6673C25.1668 15.889 22.5552 18.5007 19.3335 18.5007C18.572 18.5007 17.8432 18.3543 17.1747 18.0879L10.3394 24.9232C10.014 25.2487 9.48634 25.2487 9.16091 24.9232L7.07757 22.8399C6.75214 22.5145 6.75214 21.9868 7.07757 21.6614L13.9129 14.8261C13.6465 14.1577 13.5002 13.4288 13.5002 12.6673Z"
                        fill="#28B57A"
                    />
                </svg>
            );
        case 'gantt-labor':
            return (
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="32" height="32" rx="16" fill="#D9FFF3" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.3335 8.50065C17.0323 8.50065 15.1668 10.3661 15.1668 12.6673C15.1668 13.3725 15.3414 14.0345 15.6489 14.6148C15.8202 14.9382 15.7605 15.3355 15.5018 15.5942L8.84534 22.2507L9.75016 23.1555L16.4066 16.4991C16.6653 16.2403 17.0626 16.1806 17.386 16.352C17.9664 16.6595 18.6283 16.834 19.3335 16.834C21.6347 16.834 23.5002 14.9685 23.5002 12.6673C23.5002 12.385 23.4722 12.1097 23.4189 11.8437L21.1728 14.0899C20.8473 14.4153 20.3197 14.4153 19.9942 14.0899L17.9109 12.0066C17.5855 11.6811 17.5855 11.1535 17.9109 10.8281L20.1571 8.58188C19.8911 8.52861 19.6158 8.50065 19.3335 8.50065ZM13.5002 12.6673C13.5002 9.44565 16.1118 6.83398 19.3335 6.83398C20.3172 6.83398 21.2464 7.07818 22.0613 7.50996C22.295 7.63375 22.456 7.86107 22.4953 8.12254C22.5345 8.38401 22.4474 8.64861 22.2604 8.83557L19.6787 11.4173L20.5835 12.3221L23.1652 9.7404C23.3522 9.55343 23.6168 9.46629 23.8783 9.50556C24.1397 9.54483 24.3671 9.70586 24.4909 9.9395C24.9226 10.7544 25.1668 11.6836 25.1668 12.6673C25.1668 15.889 22.5552 18.5007 19.3335 18.5007C18.572 18.5007 17.8432 18.3543 17.1747 18.0879L10.3394 24.9232C10.014 25.2487 9.48634 25.2487 9.16091 24.9232L7.07757 22.8399C6.75214 22.5145 6.75214 21.9868 7.07757 21.6614L13.9129 14.8261C13.6465 14.1577 13.5002 13.4288 13.5002 12.6673Z"
                        fill="#28B57A"
                    />
                </svg>
            );
        case 'purchase':
            return (
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="32" height="32" rx="16" fill="#F2F0FF" />
                    <path
                        d="M6 13C11.2721 11.4379 19.5 9 19.5 9L25 12.5M6 13C8.14788 14.3668 11.5 16.5 11.5 16.5M6 13C6 15.5384 6 19.5 6 19.5L11.5 23M25 12.5L11.5 16.5M25 12.5V19L11.5 23M11.5 16.5V23"
                        stroke="#8A4ED6"
                        strokeWidth="1.5"
                    />
                    <path
                        d="M12 13.1172L13.5738 13.9964"
                        stroke="#8A4ED6"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M15 12.1172L16.5738 12.9964"
                        stroke="#8A4ED6"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M18 11.1172L19.5738 11.9964"
                        stroke="#8A4ED6"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                </svg>
            );
        case 'gantt-mhd':
            return (
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="32" height="32" rx="16" fill="#F2F0FF" />
                    <path
                        d="M6 13C11.2721 11.4379 19.5 9 19.5 9L25 12.5M6 13C8.14788 14.3668 11.5 16.5 11.5 16.5M6 13C6 15.5384 6 19.5 6 19.5L11.5 23M25 12.5L11.5 16.5M25 12.5V19L11.5 23M11.5 16.5V23"
                        stroke="#8A4ED6"
                        strokeWidth="1.5"
                    />
                    <path
                        d="M12 13.1172L13.5738 13.9964"
                        stroke="#8A4ED6"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M15 12.1172L16.5738 12.9964"
                        stroke="#8A4ED6"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M18 11.1172L19.5738 11.9964"
                        stroke="#8A4ED6"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                </svg>
            );
        case 'payment-plan':
            return (
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="32" height="32" rx="16" fill="#E7F4FE" />
                    <g clipPath="url(#clip0_4165_5009)">
                        <path
                            d="M17.6665 7.83268C17.1276 7.72268 16.5721 7.66713 15.9998 7.66602C11.3973 7.66602 7.6665 11.3968 7.6665 15.9993C7.6665 20.6018 11.3973 24.3327 15.9998 24.3327C20.6023 24.3327 24.3332 20.6018 24.3332 15.9993C24.3321 15.4271 24.2765 14.8716 24.1665 14.3327"
                            stroke="#1094F7"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M15.9997 13.4993C15.0788 13.4993 14.333 14.0593 14.333 14.7493C14.333 15.4393 15.0788 15.9993 15.9997 15.9993C16.9205 15.9993 17.6663 16.5593 17.6663 17.2493C17.6663 17.9393 16.9205 18.4993 15.9997 18.4993M15.9997 13.4993C16.7247 13.4993 17.343 13.8468 17.5713 14.3327M15.9997 13.4993V12.666M15.9997 18.4993C15.2747 18.4993 14.6563 18.1518 14.428 17.666M15.9997 18.4993V19.3327"
                            stroke="#1094F7"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M24.3315 7.66815L20.8515 11.1498M20.8515 11.1498C20.714 11.3237 20.6322 11.6644 21.2865 11.7115M20.8515 11.1498C20.6554 11.2418 20.2632 11.2761 20.2632 10.6782M20.1649 8.10315L20.2632 10.6782M20.2632 10.6782C20.2632 11.2857 20.6257 11.664 21.2865 11.7115M21.2865 11.7115L23.8899 11.834"
                            stroke="#1094F7"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_4165_5009">
                            <rect width="20" height="20" fill="white" transform="translate(6 6)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case 'payment-request':
            return (
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="32" height="32" rx="16" fill="#E7F4FE" />
                    <g clipPath="url(#clip0_4165_5009)">
                        <path
                            d="M17.6665 7.83268C17.1276 7.72268 16.5721 7.66713 15.9998 7.66602C11.3973 7.66602 7.6665 11.3968 7.6665 15.9993C7.6665 20.6018 11.3973 24.3327 15.9998 24.3327C20.6023 24.3327 24.3332 20.6018 24.3332 15.9993C24.3321 15.4271 24.2765 14.8716 24.1665 14.3327"
                            stroke="#1094F7"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M15.9997 13.4993C15.0788 13.4993 14.333 14.0593 14.333 14.7493C14.333 15.4393 15.0788 15.9993 15.9997 15.9993C16.9205 15.9993 17.6663 16.5593 17.6663 17.2493C17.6663 17.9393 16.9205 18.4993 15.9997 18.4993M15.9997 13.4993C16.7247 13.4993 17.343 13.8468 17.5713 14.3327M15.9997 13.4993V12.666M15.9997 18.4993C15.2747 18.4993 14.6563 18.1518 14.428 17.666M15.9997 18.4993V19.3327"
                            stroke="#1094F7"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M24.3315 7.66815L20.8515 11.1498M20.8515 11.1498C20.714 11.3237 20.6322 11.6644 21.2865 11.7115M20.8515 11.1498C20.6554 11.2418 20.2632 11.2761 20.2632 10.6782M20.1649 8.10315L20.2632 10.6782M20.2632 10.6782C20.2632 11.2857 20.6257 11.664 21.2865 11.7115M21.2865 11.7115L23.8899 11.834"
                            stroke="#1094F7"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_4165_5009">
                            <rect width="20" height="20" fill="white" transform="translate(6 6)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case 'supply-request':
            return (
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="32" height="32" rx="16" fill="#FFEADA" />
                    <path
                        d="M6.8335 10.166V20.9994H8.50016C8.50016 22.3802 9.61933 23.4994 11.0002 23.4994C12.381 23.4994 13.5002 22.3802 13.5002 20.9994H18.5002C18.5002 22.3802 19.6193 23.4994 21.0002 23.4994C22.381 23.4994 23.5002 22.3802 23.5002 20.9994H25.1668V16.8327L23.1274 12.7539C22.8449 12.1889 22.2682 11.8327 21.6366 11.8327H19.3335V10.166L6.8335 10.166ZM8.50016 11.8327H17.6668V19.3327H12.8507C12.3932 18.8249 11.7376 18.4994 11.0002 18.4994C10.2627 18.4994 9.60714 18.8249 9.14958 19.3327H8.50016V11.8327ZM14.786 13.1169L12.6668 15.2376L11.4233 13.9941L10.245 15.1725L12.6668 17.5944L15.966 14.2969L14.786 13.1169ZM19.3335 13.4993H21.6366L23.5002 17.2266V19.3327H22.8508C22.3932 18.8249 21.7376 18.4993 21.0002 18.4993C20.3568 18.4993 19.7765 18.7495 19.3335 19.1488L19.3335 13.4993ZM11.0002 19.9577C11.5743 19.9577 12.0418 20.4252 12.0418 20.9994C12.0418 21.5735 11.5743 22.041 11.0002 22.041C10.426 22.041 9.9585 21.5735 9.9585 20.9994C9.9585 20.4252 10.426 19.9577 11.0002 19.9577ZM21.0002 19.9577C21.5743 19.9577 22.0418 20.4252 22.0418 20.9994C22.0418 21.5735 21.5743 22.041 21.0002 22.041C20.426 22.041 19.9585 21.5735 19.9585 20.9994C19.9585 20.4252 20.426 19.9577 21.0002 19.9577Z"
                        fill="#FF8F28"
                    />
                </svg>
            );
        default:
            return (
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="32" height="32" rx="16" fill="#D9FFF3" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.3335 8.50065C17.0323 8.50065 15.1668 10.3661 15.1668 12.6673C15.1668 13.3725 15.3414 14.0345 15.6489 14.6148C15.8202 14.9382 15.7605 15.3355 15.5018 15.5942L8.84534 22.2507L9.75016 23.1555L16.4066 16.4991C16.6653 16.2403 17.0626 16.1806 17.386 16.352C17.9664 16.6595 18.6283 16.834 19.3335 16.834C21.6347 16.834 23.5002 14.9685 23.5002 12.6673C23.5002 12.385 23.4722 12.1097 23.4189 11.8437L21.1728 14.0899C20.8473 14.4153 20.3197 14.4153 19.9942 14.0899L17.9109 12.0066C17.5855 11.6811 17.5855 11.1535 17.9109 10.8281L20.1571 8.58188C19.8911 8.52861 19.6158 8.50065 19.3335 8.50065ZM13.5002 12.6673C13.5002 9.44565 16.1118 6.83398 19.3335 6.83398C20.3172 6.83398 21.2464 7.07818 22.0613 7.50996C22.295 7.63375 22.456 7.86107 22.4953 8.12254C22.5345 8.38401 22.4474 8.64861 22.2604 8.83557L19.6787 11.4173L20.5835 12.3221L23.1652 9.7404C23.3522 9.55343 23.6168 9.46629 23.8783 9.50556C24.1397 9.54483 24.3671 9.70586 24.4909 9.9395C24.9226 10.7544 25.1668 11.6836 25.1668 12.6673C25.1668 15.889 22.5552 18.5007 19.3335 18.5007C18.572 18.5007 17.8432 18.3543 17.1747 18.0879L10.3394 24.9232C10.014 25.2487 9.48634 25.2487 9.16091 24.9232L7.07757 22.8399C6.75214 22.5145 6.75214 21.9868 7.07757 21.6614L13.9129 14.8261C13.6465 14.1577 13.5002 13.4288 13.5002 12.6673Z"
                        fill="#28B57A"
                    />
                </svg>
            );
    }
};
